export type HelpCenterUserContextValue =
  | string
  | number
  | boolean
  | null
  | undefined;

export type HelpCenterUserContext = Record<string, HelpCenterUserContextValue>;

export interface CrmUserContext {
  country_code?: string;
  user_type?: string;
  plan_type?: string;
  is_paid_user?: boolean;
}

export function crmUserContext(context: CrmUserContext): CrmUserContext {
  return context;
}
